import qs from 'query-string';
import { useLocation } from 'react-router-dom';

export function useCurrentEmail(): string | undefined {
  const location = useLocation();

  const params = qs.parse(location.search);
  return (params.id || params.email) as string;
}
